<template>
  <div class="orderDetails" id="order-detail">
    <div class="personal-box comWidth">
      <div class="personal-right">
        <NavT :titleS="titleS"/>
        <div class="rightmain">

          <!--步骤条-->
          <el-steps :active="progress" finish-status="success">
            <el-step title="1.提交訂單"></el-step>
            <el-step title="2.付款成功"></el-step>
            <el-step title="3.倉庫發貨"></el-step>
            <el-step title="4.確認收貨"></el-step>
          </el-steps>

          <!--订单状态-->
          <div class="orderDetail-style">
            <h5>當前狀態：
              <span v-if="detailList.pay_status == 0 && detailList.order_status == 0"> 待付款</span>
              <span v-else-if="detailList.pay_status == 0 && detailList.order_status == -1"> 已取消</span>
              <span v-else-if="detailList.pay_status == 0 && detailList.order_status == -2"> 已失效</span>
              <span v-else-if="(detailList.deliver_status === 0 || detailList.deliver_status === 1 ) && detailList.pay_status === 1 &&　(detailList.order_status === 1 || detailList.order_status === 0)"> 待發貨</span>
              <span v-else-if="detailList.pay_status == 1 && detailList.order_status == 1 && detailList.deliver_status === 2"> 待收貨</span>
              <span  v-else-if="detailList.pay_status == 1 && detailList.order_status == 2"> 已完成</span>
            </h5>
            <p v-if="detailList.pay_status == 0 && detailList.order_status == 0">請及時付款</p>
            <div class="option">
              <button class="go-paybtn"
                      v-if="detailList.pay_status == 0 && detailList.order_status == 0"
                      type="button"
                      @click="goToPay">去支付</button>
              <a class="go-paybtn go"
                 v-if="detailList.pay_status == 0 && detailList.order_status == 0" @click="cancelOrder">取消訂單</a>
            </div>
          </div>

          <!--安全提醒-->
          <div class="orderDetail-tishi">
            <p>
              <i class="iconfont icon-message"></i>
              <span>安全提醒：</span>請不要將銀行卡、密碼、手機驗證碼提供給他人，極草不會通過任何非官方電話、QQ、微博、微信與您聯繫。任何以“缺貨、海關卡單、商品檢驗不合格、假貨”等理由要求您點擊山寨極草鏈接進行退款或取消訂單的行為都是欺詐！如遇此类情况，请拨打極草官方客服電話進行核实：+86 400-061-3311！
            </p>
          </div>

          <!--订单信息-->
          <div class="orderDetail-information">
            <h4>訂單信息</h4>
            <p>
              收貨地址：{{detailList.province}}{{detailList.city}}{{detailList.district}}{{detailList.address}} <br>
              訂單號：{{detailList.order_sn}} <br>
              支付金額：<span>￥{{detailList.payment_amount}}</span><br>
              下單時間：{{detailList.created_at}}	<br>
              訂單備註：{{detailList.remark}}	</p>
          </div>


          <!--商品信息-->
          <div>
            <el-table
              :data="purchaseData"
              style="width: 100%">
              <el-table-column
                label="商品信息"
                width="260">
                <template slot-scope="scope">
                  <img :src="scope.row.goods_thumb"><span>{{scope.row.goods_name}}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="發貨倉"
                width="180">
                <template  slot-scope="scope">離境仓</template>
              </el-table-column>
              <el-table-column
                label="本倉稅費"
                width="180">
                <template  slot-scope="scope">¥0.00</template>
              </el-table-column>
              <el-table-column
                prop="goods_price"
                label="單價（元）">
                <template  slot-scope="scope">¥{{scope.row.goods_price}}</template>
              </el-table-column>
              <el-table-column
                prop="goods_number"
                label="數量">
              </el-table-column>
              <el-table-column
                prop="amount"
                label="金額（元）">
                <template  slot-scope="scope">¥{{scope.row.amount}}</template>
              </el-table-column>
            </el-table>
          </div>

          <!--支付详情-->
          <div class="pay_information">
            <div class="information_main">
              <p><b>商品應付總計：</b><span>¥{{detailList.order_amount}}</span></p>
              <p><b>運費：</b><span>¥0.00</span></p>
              <p><b>稅費：</b><span>¥0.00</span></p>
              <p><b>活動優惠：</b><span>¥{{(parseFloat(detailList.order_amount)-parseFloat(detailList.payment_amount)).toFixed(2)}}</span></p>
              <p><b>應付金額：</b><span class="yingfu">￥{{detailList.payment_amount}}</span></p>
            </div>
          </div>


        </div>
    </div>
    </div>
  </div>
</template>

<script>
  //nav
  import NavT from '@/pages/personalPage/NavT'
  //api
  import {orderList ,updateOrder} from '@/api/order';
  //common.js
  import {getLocalStorage,setLocalStorage , ifSignIn} from '@/utils/common';
  export default {
    name: 'OrderDetails',
    components:{
      NavT
    },
    data () {
      return {
        titleS:'訂單詳情',
        //订单进度
        progress:0,
        //订单信息
        purchaseData:[],
        //所有订单
        allOrders:[],
        allState:{
          order_status:undefined,
          pay_status:undefined,
          deliver_status:undefined
        },
        //订单id
        orderId:this.$route.query.orderId,
        //详情数据
        detailList:{},
        //当前订单的支付方式
        payment_method:'',
      }
    },
    methods:{
      /*全部订单*/
      goodsOrderList(){
          this.detailList = JSON.parse(sessionStorage.getItem('detailList'));
        console.log('this.detailList',this.detailList)
          this.payment_method = JSON.parse(sessionStorage.getItem('orderMsg'));
          if(this.detailList){
            //支付方式
            this.purchaseData =  this.detailList.goods.data;
            //进度判断
            if(this.detailList.pay_status == 0 && this.detailList.order_status == 0){
              this.progress = 1
            }else if((this.detailList.deliver_status === 0 || this.detailList.deliver_status === 1 ) && this.detailList.pay_status === 1 &&　(this.detailList.order_status === 1 || this.detailList.order_status === 0)){
              this.progress = 2
            }else if(this.detailList.pay_status == 1 && this.detailList.deliver_status == 2 && this.detailList.order_status !== 2){
              this.progress = 3
            }else if(this.detailList.pay_status == 1 && this.detailList.order_status == 2){
              this.progress = 4
            }else {
              this.progress = 0
            }
          }
      },

      /*去支付*/
      goToPay(){
        ifSignIn(this, () =>{
      /*    var obj = {id:this.orderId,meta:{payment_method:this.payment_method}};
          getLocalStorage('orderMsg' ,res=>{
            var orderMsg = res;
            orderMsg.id = this.orderId;
            setLocalStorage('orderMsg',orderMsg);
          })*/
          var orderMsg = {
            payment_method:this.payment_method,
            id:this.orderId
          }
          setLocalStorage('orderMsg',orderMsg);
          this.$router.push({name:'OrderPayment',query:{id:this.orderId}})
          this.goodsOrderList();
        });
      },

      /*取消订单*/
      cancelOrder(){
        updateOrder({order_status:-1},this.orderId).then(res=>{
          this.detailList.order_status = -1;
          sessionStorage.setItem('detailList',JSON.stringify(this.detailList))
          this.$message.success('取消訂單成功');
          this.goodsOrderList();
        })
      },
    },
    created(){
        //全部订单
        this.goodsOrderList();
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">

.orderDetails{
  .rightmain{
    &>div{
    margin-bottom: 20px;
      }
  }
  .personal-right{
    width: 1200px;
    .orderDetail-style{
      padding: 28px 50px;
      border: 1px solid #e5e5e5;
      overflow: hidden;
      margin-top: 20px;
      h5{
        font-size: 20px;
        font-weight: bold;
      }
      p{
        display: block;
        font-weight: normal;
        margin-top: 10px;
      }
      .option{
        margin-top: 24px;
      }
      .go-paybtn{
        display: inline-block;
        background-color: #e31436;
        color: #fff;
        height: 38px;
        width: 100px;
        line-height: 38px;
        text-align: center;
      }
      .go{
        background: #afaaaa;
      }
    }

    .orderDetail-tishi{
      overflow: hidden;
      background-color: #fff8db;
      border: 1px solid #e5e5e5;
      padding: 16px 10px;
      p{
        line-height: 24px;
        i{
          display: inline-block;
          width: 16px;
          height: 16px;
          background: url(../../../assets/icon/small_tip.svg) no-repeat;
          background-size: cover;
          vertical-align: middle;
          margin-right: 8px;
        }
        span{
          color: #e31436;
        }
      }
    }

    .orderDetail-information{
      padding: 30px;
      border: 1px solid #e5e5e5;
      overflow: hidden;
      h4{
        border-bottom: 1px solid #e5e5e5;
        font-size: 16px;
        padding-bottom: 18px;
      }
      p{
        font-size: 14px;
        line-height: 26px;
        margin-top: 13px;
      }
      span{
        color: #e31436;
      }
    }

    .pay_information{
      background-color: #f6f6f6;
      padding: 50px 26px;
      text-align: right;
      font-size: 16px;
      line-height: 30px;
      p{
        .yingfu{
          color: #e20000;font-weight: bold;
        }
      }
    }
  }
  .information_main{
    padding-left:75%;
    p{
      width: 100%;
      display: flex;
      b{
        width: 50%;
        text-align: right;
      };
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personalPage/orderCenter/OrderDetails.vue